import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ProductBagClose = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M17.5 7.25H16.7206C16.4655 3.8309 14.4842 1.25 12 1.25C9.5158 1.25 7.5344 3.8309 7.2794 7.25H6.5C4.9834 7.25 3.75 8.4834 3.75 10V16C3.75 19.7217 6.7778 22.75 10.5 22.75H13.5C17.2217 22.75 20.25 19.7217 20.25 16V10C20.25 8.4834 19.0166 7.25 17.5 7.25ZM12 2.75C13.6033 2.75 14.9669 4.7468 15.2015 7.25H8.7984C9.0331 4.7468 10.3967 2.75 12 2.75ZM6.5 8.75H17.5C18.0111 8.75 18.4488 9.0598 18.6423 9.5H5.3577C5.5512 9.0598 5.9889 8.75 6.5 8.75ZM13.5 21.25H10.5C7.605 21.25 5.25 18.8945 5.25 16V10.5H6.25V13.5C6.25 13.9141 6.5859 14.25 7 14.25C7.4141 14.25 7.75 13.9141 7.75 13.5V10.5H18.75V16C18.75 18.8945 16.3945 21.25 13.5 21.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ProductBagClose.displayName = 'ProductBagClose';
